import Button from './Button'
import CircularProgressBar from './CircularProgress'
import DialogConfirm from './DialogConfirm'
import ModalCustom from './Modal'
import Pagination from './Pagination'
import Search from './Search'
import Table from './Table'
import Tabs from './Tabs'
import TextInput from './TextInput'

export {
  Button,
  CircularProgressBar,
  DialogConfirm,
  ModalCustom as Modal,
  Pagination,
  Search,
  Table,
  Tabs,
  TextInput,
}
